import type { SubscriptionOverviewResponse } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { SubscriptionStatusEnum } from "@nlc/shared-types";
import { useQuery } from "@tanstack/react-query";

import { subscriptionKeys } from "@/hooks/queryKeys";
import { useUser } from "@/hooks/useUser";

import { MOCK_DEFAULT_CARD } from "../../payment-methods/hooks/usePaymentMethods";

export function useSubscriptionOverview(
  projectId: number,
): UseQueryResult<SubscriptionOverviewResponse> {
  const { data: userData } = useUser();

  return useQuery<SubscriptionOverviewResponse>({
    enabled: !!userData,
    queryFn: () => {
      const project = userData!.projects.find((p) => p.id === projectId);

      if (!project) {
        throw new Error("Project not found");
      }

      return {
        account: {
          id: project.id,
          name: project.name,
        },
        addOns: null,
        paymentFailure:
          project.subscriptionStatus.subscriptionStatus ===
          SubscriptionStatusEnum.DUNNING_PROCESS
            ? {
                paymentMethod: {
                  brand: MOCK_DEFAULT_CARD.brand,
                  last4: MOCK_DEFAULT_CARD.last4,
                  type: MOCK_DEFAULT_CARD.type,
                },
                reason: "technical",
              }
            : null,
        paymentMethods: null,
        plan: {
          designSlotCount: null,
          productName: project.product,
          supportTier: null,
        },
        subscriptionStatus: project.subscriptionStatus.subscriptionStatus,
        upcomingPayment: {
          amount: project.price,
          currency: "USD",
          discount: null,
          renewalDate: new Date(project.nextBillingDate).toISOString(),
        },
      };
    },
    queryKey: subscriptionKeys.overview(projectId),
  });
}
